// Transitions PR-1 — query-key factory. queryKey arrays live ONLY in *Keys
// files (stale-after-save convention).

export const loanTransitionsKeys = {
  all: ["portfolio-admin", "transitions"] as const,
  list: (loanId: string) =>
    ["portfolio-admin", "transitions", "loan", loanId] as const,
  detail: (loanId: string, transitionId: string) =>
    ["portfolio-admin", "transitions", "loan", loanId, "detail", transitionId] as const,
  quotePreview: (loanId: string, asOf: string | undefined) =>
    ["portfolio-admin", "transitions", "quote", loanId, asOf ?? "today"] as const,
  quoteHistory: (loanId: string) =>
    ["portfolio-admin", "transitions", "quote-history", loanId] as const,
  console: () => ["portfolio-admin", "transitions", "console"] as const,
  bmspCountdown: (loanId: string) =>
    ["portfolio-admin", "transitions", "bmsp", loanId] as const,
  bmspQueue: () => ["portfolio-admin", "transitions", "bmsp-queue"] as const,
  linkableDeals: () =>
    ["portfolio-admin", "transitions", "linkable-deals"] as const,
};
